/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import Icon from "react-icons-kit";

import history from "../../history";
import { ic_mode_edit } from "react-icons-kit/md/ic_mode_edit";
import Thumb from "../../assets/images/classic.jpg";
import CustomButton from "../CustomButton";
import config from "../../utils/config";

import get from "lodash/get";

const _ = { get };

function Branch(props) {
  let { elements } = props;

  const handleRowData = (e, rowData) => {
    history.push(`/branch/detail?branchId=${rowData._id}&page=${props.page - 1}&countryCode=${props.countryCode}&country=${props.country}&state=${props.state}&city=${props.city}&count=${props.count}&dealerEmail=${props.dealerEmail}&dealerPhone=${props.dealerPhone}&dealerId=${props.dealerId}`);
  };
  return (
    <React.Fragment>
      <Row>
        <Col md="12">
          <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor"></h2>
        </Col>
        { props.dealerBranchData.length !== 0 ? (
          props.dealerBranchData.map((item, index) => (
            <Col key={ index } xs={ 12 } md={ 6 } sm={ 6 } xl={ 4 } className="mb-3">
              <Card className="byk-card">
                <CardBody className="p-2">
                  <div className="d-flex flex-column">
                    <figure className="profile m-0">
                      <img
                        src={
                          item.primary_image
                            ? `${config.imageBaseUrl}${item.primary_image}`
                            : Thumb
                        }
                        className="w-100 rounded"
                        alt=""
                      />
                    </figure>
                    <div className="w-100  ml-auto information px-2 py-2 position-relative">
                      <Icon
                        className="editIcon"
                        onClick={ (e) => handleRowData(e, item) }
                        icon={ ic_mode_edit }
                      />

                      <div className="d-flex flex-column">
                        <span className="text-capitalize d-flex flex-row pr-2">
                          <span className="mr-2 title">
                            { _.get(
                              elements,
                              "dealerDetailElements.dynamicBranchNameLabel",
                              "Name:"
                            ) }
                          </span>
                          <span className="detail">{ item.branchName }</span>
                        </span>

                        <span className="text-capitalize d-flex flex-row pr-2">
                          <span className="mr-2 title">
                            { " " }
                            { _.get(
                              elements,
                              "dealerDetailElements.dynamicBranchCodeLabel",
                              "Branch Code:"
                            ) }
                            -
                          </span>
                          <span className="detail">{ item.branchCode }</span>
                        </span>
                        <span className="text-capitalize d-flex flex-row pr-2">
                          <span className="mr-2 title">
                            { " " }
                            { _.get(
                              elements,
                              "dealerDetailElements.dynamicBranchCountryLabel",
                              "Country:"
                            ) }
                            -
                          </span>
                          <span className="detail">{ item.country }</span>
                        </span>
                        <span className="text-capitalize d-flex flex-row pr-2">
                          <span className="mr-2 title">
                            { " " }
                            { _.get(
                              elements,
                              "dealerDetailElements.dynamicBranchStateLabel",
                              "State:"
                            ) }
                            -
                          </span>
                          <span className="detail">{ item.state }</span>
                        </span>
                        <span className="text-capitalize d-flex flex-row pr-2">
                          <span className="mr-2 title">
                            { " " }
                            { _.get(
                              elements,
                              "dealerDetailElements.dynamicBranchCityLabel",
                              "City:"
                            ) }
                            -
                          </span>
                          <span className="detail">{ item.city }</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))
        ) : (
          <Col md="12">
            <h4 className="text-center">
              { _.get(
                elements,
                "dealerDetailElements.noBranchFoundText",
                "No Branches Available"
              ) }
            </h4>
          </Col>
        ) }

        { props.dealerBranchData.length !== 0 ? null : (
          <Col md="12">
            <div className="d-flex justify-content-center  position-relative my-3  ">
              <CustomButton
                customType={ "button" }
                name={ _.get(
                  elements,
                  "dealerDetailElements.addButtonElement",
                  "Add"
                ) }
                customClass={
                  "btn-outline-dark bg-none btnthemeColor customButtonSmall"
                }
                customClick={ props.handleToCreateForm }
              />
            </div>
          </Col>
        ) }
      </Row>
    </React.Fragment>
  );
}
export default Branch;
